export interface ICustomUrl {
    link: string;
    page: string;
    contractNeeded: string;
    url: string;
    redirectInProgress: boolean;
    ruleType: RuleType;
    acronym: string;
    partnerId: string;
    individualChallengeId: string;
    collectiveChallengeId: string;
    eventCode: string;
}

export enum RuleType {
    FUNCIONA = "funciona",
    SAUDE = "saude",
    PLANETA = "planeta",
    DEFAULT = "default",
    SERVICO = "servico"
}

